module.exports = __webpack_public_path__ + "static/media/aaj_bg_1.7179d601.jpg";